<template>
  <div class="form-item">
    <div class="form-box-item">
      <select v-model="inputValue" >
        <option value="" disabled selected>Szolgáltatás Típusa</option>
        <option  v-for="(data,key) in fieldOptions" v-bind:key="key" :value="key">{{ data['label'] }}</option>
      </select>
      <span class="arrow">
        <span class="glyphicon glyphicon-chevron-down"></span>
      </span>
    </div>
  </div>
</template>
<script>
import {fieldMixin} from '../../mixin/field'
import {miniFieldMixin} from '../../mixin/minifield'

export default {
  name: "ServiceType",
  mixins: [
    fieldMixin,
    //use mixin with argument
    miniFieldMixin(function(value) {
      return value != ''
    })
  ]
}
</script>
<style lang="scss" scoped>
.form-item > .form-box-item {
  select {
    line-height: normal;
    border: none;
    width: 100%;
  }
  span.arrow{
    position: absolute;
  }
  span.glyphicon{
    opacity: .6;
    position: relative;
    z-index: 3;
    line-height: 46px;
    right: 18.5px;
    color: #444;
  }
}
</style>
